import { NETWORK_ADMIN_ROLE, NETWORK_MANAGER_ROLE } from '@app/../shared/constants';
import { ComingSoon } from '@app/components';
import { Logs } from './Logs';
import { NetworkAnalyticsDetailPage } from './NetworkAnalyticsDetailPage';
import { NetworkAnalyticsPage } from './NetworkAnalyticsPage';
// import { NetworkBillingConnectPage } from './NetworkBillingConnectPage';
// import { NetworkBillingMembershipPage } from './NetworkBillingMembershipPage';
// import { NetworkBillingPage } from './NetworkBillingPage';
// import { NetworkBillingPaymentMethodPage } from './NetworkBillingPaymentMethodPage';
import { NetworkInterestsPage } from './NetworkInterestsPage';
import { NetworkInvitationsPage } from './NetworkInvitationsPage';
import { NetworkKnowledgePage } from './NetworkKnowledgePage';
import { NetworkPendingPage } from './NetworkPendingPage';
import { NetworkSettingsPage } from './NetworkSettingsPage';
import { NetworksPage } from './NetworksPage';
import { NetworkUsersAllPage } from './NetworkUsersAllPage';
import { NetworkUsersPage } from './NetworkUsersPage';
import { NetworkUsersPendingPage } from './NetworkUsersPendingPage';
import { NetworkUsersRequestPage } from './NetworkUsersRequestPage';
import { UsersPage } from './UsersPage';

export const routes = [
  {
    key: '/members',
    exact: true,
    path: '/networks/:id/members/',
    component: NetworkUsersPage,
    permission: [NETWORK_ADMIN_ROLE],
    baseRouter: true,
  },
  {
    key: '/members/requests',
    exact: true,
    path: '/networks/:id/members/requests',
    component: NetworkUsersRequestPage,
    permission: [NETWORK_ADMIN_ROLE],
  },
  {
    key: '/members/pendings',
    exact: true,
    path: '/networks/:id/members/pendings',
    component: NetworkUsersPendingPage,
    permission: [NETWORK_ADMIN_ROLE],
  },
  {
    key: '/members/all',
    exact: true,
    path: '/networks/:id/members/all',
    component: NetworkUsersAllPage,
    permission: [NETWORK_ADMIN_ROLE],
  },
  {
    key: '/pending',
    exact: true,
    path: '/networks/:id/pending-posts',
    component: NetworkPendingPage,
    permission: [NETWORK_ADMIN_ROLE, NETWORK_MANAGER_ROLE],
    baseRouter: true,
  },
  {
    key: '/analytics',
    exact: true,
    path: '/networks/:id/analytics',
    component: NetworkAnalyticsPage,
    permission: [NETWORK_ADMIN_ROLE, NETWORK_MANAGER_ROLE],
    baseRouter: true,
  },
  {
    key: '/analytics/details',
    exact: true,
    path: '/networks/:id/analytics/details',
    component: NetworkAnalyticsDetailPage,
    permission: [NETWORK_ADMIN_ROLE, NETWORK_MANAGER_ROLE],
  },
  {
    key: '/interests',
    exact: true,
    path: '/networks/:id/interests',
    component: NetworkInterestsPage,
    permission: [NETWORK_ADMIN_ROLE, NETWORK_MANAGER_ROLE],
    baseRouter: true,
  },
  {
    key: '/settings',
    exact: true,
    path: '/networks/:id/settings',
    component: NetworkSettingsPage,
    permission: [NETWORK_ADMIN_ROLE],
    baseRouter: true,
  },
  // {
  //   key: '/billing',
  //   exact: true,
  //   path: '/networks/:id/billing',
  //   component: NetworkBillingPage,
  //   permission: [NETWORK_ADMIN_ROLE, MEMBER_ROLE],
  //   baseRouter: true,
  // },
  // {
  //   key: '/billing/connect',
  //   exact: true,
  //   path: '/networks/:id/billing/connect',
  //   component: NetworkBillingConnectPage,
  //   permission: [NETWORK_ADMIN_ROLE, MEMBER_ROLE],
  //   baseRouter: false,
  // },
  // {
  //   key: '/billing/connect',
  //   exact: true,
  //   path: '/networks/:id/billing/payment-method',
  //   component: NetworkBillingPaymentMethodPage,
  //   permission: [NETWORK_ADMIN_ROLE, MEMBER_ROLE],
  //   baseRouter: false,
  // },
  // {
  //   key: '/billing/connect',
  //   exact: true,
  //   path: '/networks/:id/billing/membership',
  //   component: NetworkBillingMembershipPage,
  //   permission: [NETWORK_ADMIN_ROLE, MEMBER_ROLE],
  //   baseRouter: false,
  // },
  // {
  //   key: '/billing',
  //   exact: true,
  //   path: '/networks/:id/billing/:status',
  //   component: NetworkBillingPage,
  //   permission: [NETWORK_ADMIN_ROLE, MEMBER_ROLE],
  //   baseRouter: true,
  // },
  // {
  //   key: '/members',
  //   exact: true,
  //   path: '/networks/:id',
  //   component: ComingSoon,
  //   permission: [NETWORK_ADMIN_ROLE],
  // },
  {
    key: '/knowledge',
    exact: true,
    path: '/networks/:id/knowledge',
    component: NetworkKnowledgePage,
    permission: [NETWORK_ADMIN_ROLE],
    baseRouter: true,
  },
  {
    key: '/invitations',
    exact: true,
    path: '/networks/:id/invitations',
    component: NetworkInvitationsPage,
    permission: [NETWORK_ADMIN_ROLE],
    baseRouter: true,
  },
  {
    key: '/networks',
    exact: true,
    path: '/networks',
    component: NetworksPage,
    permission: [NETWORK_ADMIN_ROLE],
    baseRouter: true,
  },
  {
    key: '/users',
    exact: true,
    path: '/users',
    component: UsersPage,
    permission: [NETWORK_ADMIN_ROLE],
    baseRouter: true,
  },
  {
    key: '/knowledge',
    exact: true,
    path: '/knowledge',
    component: ComingSoon,
    permission: [NETWORK_ADMIN_ROLE],
    baseRouter: true,
  },
  {
    key: '/logs',
    exact: true,
    path: '/logs',
    component: Logs,
    baseRouter: true,
  },
];
